<div class="container container-fixed">
  @if (hasAnyFtpProvider() && ftpConnectionWorks()) {
  <div class="btn-toolbar">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="['Partner_Action_FtpCreate', 'Partner_Action_InternalPartner']; type:'And'; evaluator:evaluatePermissions; trigger: selectedPartner"
      [disabled]="currentIntegratedFtpConfiguration() || isCreatingNew() || showFilesVisible()" (click)="create()">Create Ftp Account</button>
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="['Partner_Action_FtpDelete', 'Partner_Action_InternalPartner']; type:'And'; evaluator:evaluatePermissions; trigger: selectedPartner"
      [disabled]="!currentIntegratedFtpConfiguration() || isCreatingNew() || showFilesVisible()" (click)="delete()">Delete Ftp Account</button>
    @if (currentIntegratedFtpConfiguration() && showFilesbutton()) {
    <button class="btn btn-primary btn-sm" (click)="toggleShowFiles()"> {{getShowFilesButtonText()}}</button>
    }
  </div>
  <br class="xs-20" />
  <div [hidden]="isCreatingNew() || !currentIntegratedFtpConfiguration() || showFilesVisible()">
    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label>Username</label>
          @if (canChangeUsername()) {
          <div class="input-group">
            <input class="form-control" type="text" [ngModel]="$safeNavigationMigration(currentIntegratedFtpConfiguration()?.Username)" readonly />
            <span class="input-group-btn">
              <button class="btn btn-default" (click)="changeUsername()" type="button"
                *bizPermissionRequired="['Partner_Action_FtpChangeUsername', 'Partner_Action_InternalPartner']; type:'And'; evaluator:evaluatePermissions; trigger: selectedPartner">Change
                <span class="glyphicon glyphicon-edit"></span></button>
            </span>
          </div>
          }
          @else {
          <input class="form-control" type="text" [ngModel]="$safeNavigationMigration(currentIntegratedFtpConfiguration()?.Username)" readonly />
          }
        </div>
        <div class="form-group">
          <label>Relative Path</label>
          <input class="form-control" type="text" [ngModel]="$safeNavigationMigration(currentIntegratedFtpConfiguration()?.FolderPath)" readonly />
        </div>
      </div>
    </div>
    @if (showPasswordField()) {

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <app-password #ftpPwd caption="Password" [ngModel]="currentPassword()" (ngModelChange)="onPasswordChange($event)" required [disabled]="!changingPassword()"
            [allowShowPassword]="allowShowPassword()" helpText="Please enter the password according to {{ftpPluginName()}} password complexity requirements">
          </app-password>
        </div>
      </div>
      @if (supportChangePassword()) {
      <div class="col-sm-2"
        *bizPermissionRequired="['Partner_Action_FtpEdit','Partner_Action_FtpChangePassword', 'Partner_Action_InternalPartner']; type:'And'; evaluator:evaluatePermissions; trigger: selectedPartner">
        <div class="btn-toolbar v-align">
          @if (changingPassword()) {
          <button class="btn btn-primary" (click)="endChangePassword(true)" type="button" [disabled]="!passwordIsValid()">Save</button>
          <button class="btn btn-primary" (click)="endChangePassword(false)" type="button">Cancel</button>
          }
          @else {
          <button class="btn btn-primary" (click)="beginChangePassword()" type="button">Change password</button>
          }
        </div>
      </div>
      }
    </div>
    }
    <div class="row">
      <div class="col-sm-4">

        @if (showUpload()) {
        <div class="form-group">
          <button class="btn btn-primary btn-sm" (click)="changePublicKey()" type="button">Update public key<span class="glyphicon glyphicon-edit"></span></button>
        </div>
        }

        <div class="form-group">
          @if (isCreatingNew()) {
          <div class="control control-checkbox">
            <label>Exclude Integrated Ftp<input type="checkbox" [ngModel]="$safeNavigationMigration(currentIntegratedFtpConfiguration()?.ExcludeFromIntegratedFtpRetrieve)" /><i></i></label>
          </div>
          }

          @if (!isCreatingNew()) {
          <div class="form-group">
            <div class="row">
              <div class="col-sm-12">
                @if (currentIntegratedFtpConfiguration()?.ExcludeFromIntegratedFtpRetrieve) {
                <span class="label label-default">Excluded from Integrated Ftp adapter</span>
                }
                @else {
                <span class="label label-success">Included in Integrated Ftp adapter</span>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                @if (currentIntegratedFtpConfiguration()?.ExcludeFromIntegratedFtpRetrieve) {
                <button (click)="setLocalFtp(true)" style="padding-left: 0px;" class="btn btn-link">Click here to include in Integrated Ftp adapter</button>
                }
                @else {
                <button (click)="setLocalFtp(false)" style="padding-left: 0px;" class="btn btn-link">Click here to exclude from Integrated Ftp adapter</button>
                }
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  }

  <div class="" [hidden]="isCreatingNew() || currentIntegratedFtpConfiguration() || showFilesVisible()">
    <h3>No Ftp configuration created for this partner</h3>
  </div>

  <div [hidden]="!isCreatingNew() || showFilesVisible()">
    <ep-new-partner-ftp (saved)="ftpConfigurationSaved($event)" (cancelled)="cancelNew()" [canChangeUsername]="canChangeUsername()"></ep-new-partner-ftp>
  </div>

  <div [hidden]="!showFilesVisible()">
    <ep-ftp-show-files [partnerId]="$safeNavigationMigration(currentIntegratedFtpConfiguration()?.PartnerId)" [visible]="showFilesVisible()"></ep-ftp-show-files>
  </div>

  @if (!hasAnyFtpProvider()) {
  <h3>No Ftp provider is configured</h3>
  }

  @if (!ftpConnectionWorks()) {
  <h3 style="color:red">A System Integrated FTP Provider has been configured, but an error occurred when trying to communicate with it.</h3>
  <p> {{ftpConnectionError()}}</p>
  }
</div>
